module.exports = __webpack_public_path__ + "static/media/Entrepreneur.e2888b27.svg";